import React from "react";
import * as Icon from "react-feather";
import clsx from "clsx";
import { formatAmount } from "./helpers/formatters";
import { WP_REF_BY_CATEGORY } from "./helpers/constants";
import "../afs-walkthrough.css";
import WComponent from "../../../../common/WComponent";

const fmt = formatAmount;

class SectionRows extends WComponent {
	render() {
	let { section, expanded, onToggle, showComparatives, show2022, hasTransactions, onDrillAccount, onNavigateToLeadSheet } = this.props;
	const isExpanded = expanded.has(section.name);
	const wpRef = section.category ? WP_REF_BY_CATEGORY[section.category] : null;
	const wpRefClickable = Boolean(wpRef && onNavigateToLeadSheet);
	return (
		<>
			<tr className={clsx("afs-fs-table__section-row", isExpanded && "afs-fs-table__section-row--expanded")} onClick={() => onToggle(section.name)}>
				<td className="afs-fs-table__section-name">
					<span className="afs-fs-table__section-chevron-wrap">
						{isExpanded
							? <Icon.ChevronDown size={13} color="#7a90c0" />
							: <Icon.ChevronRight size={13} color="#b0b8d0" />}
						{section.name}
					</span>
				</td>
				<td
					className={clsx("afs-fs-table__wp-ref-cell", wpRefClickable && "afs-fs-table__wp-ref-cell--clickable")}
					onClick={wpRefClickable ? (e) => { e.stopPropagation(); onNavigateToLeadSheet(wpRef); } : undefined}
				>
					{wpRef || ""}
				</td>
				<td className="afs-fs-table__section-amt">{fmt(section.totalCurrent)}</td>
				{showComparatives && <td className="afs-fs-table__section-amt">{fmt(section.totalPrior)}</td>}
				{show2022 && <td className="afs-fs-table__section-amt afs-fs-table__account-amt--faded">{fmt(section.totalPriorPrior)}</td>}
			</tr>
			{isExpanded && section.accounts.map((acct, i) => (
				<tr
					key={i}
					className={clsx("afs-fs-table__account-row", hasTransactions && "afs-fs-table__account-row--clickable")}
					onClick={() => hasTransactions && onDrillAccount(acct)}
				>
					<td className="afs-fs-table__account-name">{acct.description}</td>
					<td className="afs-fs-table__wp-ref-cell" />
					<td className="afs-fs-table__account-amt">{fmt(acct.current)}</td>
					{showComparatives && <td className="afs-fs-table__account-amt">{fmt(acct.prior)}</td>}
					{show2022 && <td className="afs-fs-table__account-amt afs-fs-table__account-amt--faded">{fmt(acct.priorPrior)}</td>}
				</tr>
			))}
		</>
	);
	}
}

export default SectionRows;
